var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"title":_vm.$t('smartTags.smartTagsTitle')}},[_c('div',{class:_vm.prefixCls},[_c('div',{class:_vm.prefixCls + '__body'},[_c('HaiUpload',{attrs:{"maxSize":20},on:{"onChange":_vm.onClickSubmit}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }